import { adminHttpClient } from '../commons/adminHttpClient'

export type SaveAnnualInsuranceRequest = {
  planPeriodId: string
  providerName: string
  policyName: string
  providerStartDate: string
}

const saveAnnualInsurance = (request: SaveAnnualInsuranceRequest): Promise<void> => {
  return adminHttpClient.post(`/Benefit/SaveAnnualInsurance`, request)
}

export default saveAnnualInsurance
